import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../../../../componets/Dashboard/Driveanalysis/NoData';
import ChartLoader from '../../../../componets/Dashboard/Driveanalysis/ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../../componets/Dashboard/DashboardMain/WaterMark";

function AvgDDBar({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "<=20": { per: 0, count: 0 },
      "40": { per: 0, count: 0 },
      "60": { per: 0, count: 0 },
      "80": { per: 0, count: 0 },
      "100": { per: 0, count: 0 },
    };
    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val.B0_20.value > 0) {
          responce["<=20"] = { per: parseInt((t_val.B0_20.value / t_val.doc_count) * 100), count: parseInt(t_val.B0_20.value) };
        }
        if (t_val.B20_40.value > 0) {
          responce["40"] = { per: parseInt((t_val.B20_40.value / t_val.doc_count) * 100), count: parseInt(t_val.B20_40.value) };
        }
        if (t_val.B40_60.value > 0) {
          responce["60"] = { per: parseInt((t_val.B40_60.value / t_val.doc_count) * 100), count: parseInt(t_val.B40_60.value) };
        }
        if (t_val.B60_80.value > 0) {
          responce["80"] = { per: parseInt((t_val.B60_80.value / t_val.doc_count) * 100), count: parseInt(t_val.B60_80.value) };
        }
        if (t_val.B80_100.value > 0) {
          responce["100"] = { per: parseInt((t_val.B80_100.value / t_val.doc_count) * 100), count: parseInt(t_val.B80_100.value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys = ["<=20", "40", "60", "80", "100"]
        loop_keys.map(x => {
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#83A4CF"]);
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Soc Discharge',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Discharge Cycles',
      minValue: 0,
      format: '#\'%\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="220px" data={chartdata} options={options} />)}
      </div>
    </>
  );
}

export default AvgDDBar;
